import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import Link from "next/link";
import { Description, Details } from "styles/jss/ProductsPage.styles";
import { PrimaryButton } from "styles/jss/Layout.styles";
import { Box, Divider } from "@mui/material";
import { ProductBrodCramp } from "components";

const InfoBox = ({ matches, ...props }) => {
  const { locale } = useRouter();
  const { t } = useTranslation(["products"]);
  const { name, slug, density, mfi, short_description, applications, type } =
    props;
  return (
    <>
      {matches && <ProductBrodCramp name={name} />}
      <h1>{name}</h1>
      <Box className={"detailsBoxInfo"}>
        <Details>{t("mfi")}</Details>:{" "}
        <Details className={"info"}>{mfi}</Details>
      </Box>
      <Box className={"detailsBoxInfo"}>
        <Details>{t("density")}</Details>:{" "}
        <Details className={"info"}>{density}</Details>
      </Box>
      <Box className={"detailsBoxInfo"}>
        <Details>{t("application")}</Details>:{" "}
        <Details className={"info"} locale={locale}>
          {applications?.data
            .map(item => item.attributes.application)
            .join(", ")}
        </Details>
      </Box>
      <Description locale={locale}>{short_description}</Description>

      <Link
        href={`/products/${type.data.attributes.name
          .toString()
          .toLowerCase()
          .split(" ")
          .join("-")}/${slug}/order`}
      >
        <a>
          <PrimaryButton className={"orderBtn"}>{t("orderBtn")} </PrimaryButton>
        </a>
      </Link>

      <Divider />
      <Details>
        {t("only-type")}:{" "}
        <Link
          href={`/products?type=${type.data.attributes.name
            .toString()
            .toLowerCase()
            .split(" ")
            .join("-")}`}
        >
          <a>{type.data.attributes.name}</a>
        </Link>
      </Details>
    </>
  );
};

export default InfoBox;
